module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('input', {
    staticClass: "vw-range",
    attrs: {
      "type": "range",
      "min": _vm.minimum,
      "max": _vm.maximum,
      "step": _vm.step
    },
    domProps: {
      "value": _vm.val
    },
    on: {
      "input": _vm.adjusting
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-50ba1c90!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/range.vue
// module id = 240
// module chunks = 0